/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-29 17:21:38
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 16:56:26
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/index.tsx
 */
import Layout from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { LinkModuleType } from '@/src/types/common/linkType';
import React from 'react';
import { useParams } from 'react-router-dom';
import SalesChannelHOC from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import {
  // useQueryLanguageListContentEditor,
  // // EnumAction,
  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
// import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
// import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { deleteLegalPage } from 'src/request/salesChannel/legal';
import { ChannelType } from 'src/types/common/SalesChannel';
import HOC, { EnumPage } from '../Components/EditorHOC';
import { legalPermissions } from '../Components/hooks/permission';
import CloneBtn from './CloneButton';
import Content from './Content';
import LegalSetting from './LegalSetting';
import Mini from './MiniProgramShare';
import PageSetting from './PageSetting';
import RouteBlock from './RouteBlock';
import SeoSetting from './SeoSetting';
import {
  fetchLegalPage,
  getHasModified,
  getLastModified,
  getLoaded,
  getPageName,
  getState,
  getUuid,
  resetData,
  submitLegalPage,
  updateEssentialData,
  validation,
} from './slice';
import { convertDataFromReduxToServer } from './tools';

const LegalEditor = (props) => {
  const params: any = useParams();
  const type = useSalesChannelType();
  const uuid = params.uuid;
  const { topLeft, topRight, hasModified, loaded, isPrimary } = props;

  const _webRender = () => {
    if (isPrimary) {
      return [
        { element: PageSetting, id: 'PageSetting' },
        { element: SeoSetting, id: 'SeoSetting' },
        { element: LegalSetting, id: 'LegalSetting' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
            },
          },
        },
      ];
    } else {
      return [
        { element: CloneBtn, id: 'CloneBtn' },
        { element: PageSetting, id: 'PageSetting' },
        { element: SeoSetting, id: 'SeoSetting' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
            },
          },
        },
      ];
    }
  };

  const _miniRender = () => {
    if (isPrimary) {
      return [
        { element: PageSetting, id: 'PageSetting' },
        { element: Mini, id: 'Mini' },
        { element: LegalSetting, id: 'LegalSetting' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
            },
          },
        },
      ];
    } else {
      return [
        { element: CloneBtn, id: 'CloneBtn' },
        { element: PageSetting, id: 'PageSetting' },
        { element: Mini, id: 'Mini' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
            },
          },
        },
      ];
    }
  };

  const ele = React.useMemo(() => {
    if (type === ChannelType.Website) {
      return _webRender();
    }
    if (type === ChannelType.MiniProgram) {
      return _miniRender();
    }
  }, [isPrimary, type]);

  const Child = React.useMemo(() => {
    if (loaded) {
      return ele;
    } else {
      return [];
    }
  }, [loaded, isPrimary, type]);

  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <Layout topLeft={topLeft} topRight={topRight} elements={Child} />
    </React.Fragment>
  );
};
export default SalesChannelHOC(
  HOC(LegalEditor, {
    getHasModified,
    getName: getPageName,
    _key: EnumPage.legalPage,
    validation,
    getState,
    convertDataFromReduxToServer,
    submit: submitLegalPage,
    deleteFunction: deleteLegalPage,
    getLoaded,
    getUuid,
    getData: fetchLegalPage,
    updateEssentialData,
    resetData,
    getLastModified,
    getPermissions: legalPermissions,
  }),
  { type: EnumMultiLanguageType.SalesChannelLegalPage, isStyleRequired: false },
);
